export default __webpack_public_path__ + "static/media/corporate.361064fa.png";